import React from 'react';
import { useTranslation } from 'react-i18next';
import './ClientTestimonials.css';
import Hero from '../../../../components/home/Hero/Hero';
import featuredIcons1 from '../../../../assets/images/clientsTestimonials/feauturedIcon1.svg'
import featuredIcons2 from '../../../../assets/images/clientsTestimonials/feauturedIcon2.svg'
import featuredIcons3 from '../../../../assets/images/clientsTestimonials/feauturedIcon3.svg'
import featuredIcons4 from '../../../../assets/images/clientsTestimonials/feauturedIcon4.svg'
import globalItemsImg from '../../../../assets/images/about/offshore-advisory-background.png'
import recommendedIcon1 from '../../../../assets/images/clientsTestimonials/recommendedItemIcon1.svg'
import recommendedIcon2 from '../../../../assets/images/clientsTestimonials/recommendedItemIcon2.svg'
import recommendedIcon3 from '../../../../assets/images/clientsTestimonials/recommendedItemIcon3.svg'
import recommendedIcon4 from '../../../../assets/images/clientsTestimonials/recommendedItemIcon4.svg'
import { Link } from 'react-router-dom';
import useLangLink from "../../../../utils/useLangLink";
import SEO from "../../../../utils/SEO";




export default function ClientTestimonials() {
    const { t } = useTranslation();
    const lp = useLangLink();
    const tp = (k, d) => t(`pages.client-testimonials.${k}`, d);

    const featuredIcons = [featuredIcons1, featuredIcons2, featuredIcons3, featuredIcons4];
    const featuredColors = ["#8b5cf6", "#3b82f6", "#10b981", "#f59e0b"];
    const featuredStories = (tp('featured.stories', { returnObjects: true }) || []).map((s, i) => ({
        ...s,
        emoji: featuredIcons[i],
        color: featuredColors[i],
    }));

    const breadcrumbs = [
    { name: tp('breadcrumb.home', 'Home'), link: '/' },
    { name: tp('breadcrumb.self', 'Client Testimonials'), link: '/client-testimonials' },
  ];

    const quickQuotes = tp('quick.items', { returnObjects: true }) || [];

    const recommendedIcons = [recommendedIcon1, recommendedIcon2, recommendedIcon3, recommendedIcon4];
    const benefits = (tp('recommend.benefits', { returnObjects: true }) || []).map((b, i) => ({
        ...b,
        img: recommendedIcons[i],
    }));

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/client-testimonials"
            />
            <Hero breadcrumbs={breadcrumbs} colorContent='black' backgroundImg='clientTestimonialHeader' title={tp('hero.title')} descr={tp('hero.descr')} contentCenter={true} />
              <div className='feautured-section-background'>
                        <div className='feautured-container'>
                            <h2 className='feautured-title'>
                                {tp('featured.title')}
                            </h2>
                            <div className='feaututerd-section-items-row'>
                                {featuredStories.map((item) => (
                                     <div className='feautured-section-item'>
                                        <div className='feautured-img-wrapper'>
                                            <img src={item.emoji} alt='#' />
                                        </div>
                                        <span className='feautured-item-section'>
                                            {item.category}
                                        </span>
                                        <h3 className='feautured-item-title'>
                                            {item.title}
                                        </h3>
                                        <p className='feautered-item-descr'>
                                            {item.quote}
                                        </p>
                                        <hr />
                                        <span className='feautered-item-author'>
                                            {item.author}
                                        </span>
                                        <span className='feautured-item-position'>
                                            {item.position}
                                        </span>
                                    </div>
                                ))}
                               
                            </div>
                        </div>
              </div>
              <div className='quick-quotes-container'>
                <h2 className='quick-quotes-title'>
                  {tp('quick.title')}
                </h2>
                 <div className='quick-quotes-items-row'>
                    {quickQuotes.map((item) => (
                        <div className='quick-quotes-item'>
                        <p className='quick-quotes-descr'>
                        {item.quote}
                        </p>
                        <span className='quick-quotes-author'>
                            {item.author}
                        </span>
                        <span className='quick-quotes-point'>
                            {item.position}
                        </span>
                    </div>
                    ))}
                        
                 </div>
              </div>
              <div className='clients-recommended-background'>
                <div className='clients-recommended-container'>
                    <h2 className='clients-recommended-title'>
                        {tp('recommend.title')}
                    </h2>
                    <div className='recommended-keys-row'>
                        {benefits.map((item) => (
                            <div className='recommended-item-key'>
                                <div className='recommended-img-wrapper'>
                                    <img src={item.img} />
                                </div>
                                <div className='recommended-item-content'>
                                    <h3 className='recommended-item-title'>
                                        {item.title}
                                    </h3>
                                    <span className='recommended-item-descr'>
                                        {item.desc}
                                    </span>
                                </div>
                            </div>
                        ))}
                        
                    </div>
                </div>
              </div>
              <div className='join-our-global-background'>
                <div className='join-our-global-container'>
                    <div className='join-our-global-left'>
                       <div className='content-upper'>
                         <h2 className='join-our-global-title'>
                            {tp('join.title')}
                            </h2>
                            <p className='join-our-global-descr'>
                                {tp('join.descr')}
                            </p>
                       </div>
                        <div className='join-global-btn'>
                            <Link to={lp('/newsletter')}>
                                {tp('join.button')}
                                <img src='' />
                            </Link>
                        </div>
                    </div>
                    <div className='join-our-global-right'>
                        <img src={globalItemsImg} />
                    </div>
                </div>

              </div>
              {/* <Footer /> */}
        </main>
    );
}
